import React from "react";
import i18n from "../../i18n";
import { getErrorBoundaryTexts } from "./appErrorBoundaryTexts";

/**
 * Last line of defence above the routes: without it a failed lazy import or any render error leaves
 * a blank page. Navigating to another route clears the error.
 */
class AppErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }
        // i18n.language is the logged-in artist's language and needs no loaded translation file
        const texts = getErrorBoundaryTexts(i18n.language || navigator.language);
        return (
            <div role="alert" style={{ padding: 32, textAlign: "center", fontFamily: "sans-serif" }}>
                <p>{texts.message}</p>
                <button type="button" onClick={() => window.location.reload()}>
                    {texts.reload}
                </button>
            </div>
        );
    }
}

export default AppErrorBoundary;
